import React from 'react';

export const SignupPage = React.lazy(() => import('./SignupPage'));
